<script>
import {mapMutations, mapState} from "vuex"
import {ensureSanctumSession, notifyMiniAppReady} from "../../miniAppAjax.js";

export default {
  name: "HeaderComp.vue",
  methods:{
    openModal(){
      if($(".header-menu-mobile").hasClass("show")){
        $(".header-menu-mobile").removeClass("show")
      }else{
        $(".header-menu-mobile").addClass("show")
      }
    },
    scrollToForm(){
      if(window.innerWidth < 700) {
        if($("#lead-form2").length > 0){
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#lead-form2").offset().top - 10
          }, 0);
        }else{
          $([document.documentElement, document.body]).animate({
            scrollTop: $("#lead-form").offset().top - 10
          }, 0);
        }
      }else {
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top - 30
        }, 0);
      }
    },
    goRoute(url,filter){
      let query
      if(filter){
        query = { filter : filter }
      }
      if (url !== this.$router.currentRoute.value.path) {
        this.$router.push({path: url, query: query ? query : {}})
      }else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("header").offset().top - 30
        }, 0)
      }
      this.openModal()
    },
    async auth(){
      const tg = typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp
      const maxApp = typeof window !== 'undefined' && window.WebApp

      let mini_app_provider = null
      let userData = ''

      const fmtAxiosErr = (error) => {
        let s = (error && error.message) ? error.message : String(error)
        if (error && error.response) {
          s += '\nHTTP ' + error.response.status
          const d = error.response.data
          if (d !== undefined) {
            s += '\n' + (typeof d === 'string' ? d : JSON.stringify(d))
          }
        }
        return s
      }

      if (tg && tg.initData) {
        mini_app_provider = 'telegram'
        userData = tg.initData
        tg.setHeaderColor('#fff')
        tg.setBackgroundColor('#323232')
        tg.expand()
      } else if (maxApp && maxApp.initData) {
        mini_app_provider = 'max'
        userData = maxApp.initData
      } else {
        const diag = [
          '[MiniApp] Нет initData — логин не отправлен.',
          'Telegram.WebApp: ' + (tg ? 'да' : 'нет'),
          'Telegram initData длина: ' + (tg && tg.initData ? tg.initData.length : 0),
          'MAX window.WebApp: ' + (maxApp ? 'да' : 'нет'),
          'MAX initData длина: ' + (maxApp && maxApp.initData ? maxApp.initData.length : 0),
          maxApp && maxApp.platform ? 'MAX platform: ' + maxApp.platform : ''
        ].filter(Boolean).join('\n')
        console.warn(diag)
        if (this.$router && this.$route.path !== '/') {
          void this.$router.push({ path: '/' })
        }
        return
      }

      notifyMiniAppReady()
      await ensureSanctumSession(this.axios)

      this.axios.post('/api/login', {
        telegram_user: userData,
        mini_app_provider: mini_app_provider
      })
        .then(response => {
            if (response.data.success === true) {
              if (response.data.data) {
                this.setUser(response.data.data)
              } else {
                this.getUser(null)
              }
              this.setAuth(true)
            } else {
              const msg = (response.data && response.data.message) ? response.data.message : 'Ошибка аутентификации'
              console.warn('[api/login] success=false', { mini_app_provider, msg })
              if (typeof window.Alerts !== 'undefined') {
                window.Alerts.error(msg, 'topRight', false)
              }
            }
        })
        .catch(function (error) {
            const detail = fmtAxiosErr(error)
            console.error(error)
            console.warn('[api/login] ошибка запроса', mini_app_provider, detail)
            if (typeof window.Alerts !== 'undefined') {
              window.Alerts.error(detail.split('\n')[0] || 'Ошибка запроса авторизации', 'topRight', false)
            }
        });
      },
      fadeGr(){
        $('.gradient-hidden').fadeOut(250)
      },
      getUser(fallbackUser = null){
        setTimeout(() => {
        this.axios.get('/api/user')
          .then(response => {
              // this.setAuth(true);
            const u = response.data.data ?? fallbackUser
            if (u) {
              this.setUser(u)
            }
          })
          .catch(function (error) {
              // Alerts.error('Произошла ошибка! Обратитесь в тех. поддержку!')
              console.error(error);
          });
        }, 3000);
    },
    ...mapMutations(['setUser','setAuth'])
  },
  computed:{
    ...mapState(['isAuth'])
  }
}
</script>

<template>
  <header class="left flex flex-y-center">
    <div class="header-menu left flex flex-y-center">
      <router-link class="left flex flex-xy-center logo-header-block" to="/">
        <svg class="logo-header left" width="208" height="208" viewBox="0 0 208 208" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M207.8 25.8C207.8 11.8 196.3 0.299988 182.3 0.299988H26C12 0.299988 0.5 11.8 0.5 25.8V182.1C0.5 196.1 12 207.6 26 207.6H182.3C196.3 207.6 207.8 196.1 207.8 182.1V25.8Z" fill="#1662AD"/>
          <path d="M31.2 154.9H41.7L50.9 182.4H41.5L40.2 177.6H32.8L31.5 182.4H22L31.2 154.9ZM38.1 170.6L36.4 164L34.7 170.6H38.1Z" fill="white"/>
          <path d="M53.8 154.9H66C72.6 154.9 76.7 159.1 76.7 165C76.7 170.9 72.6 175.1 66 175.1H62.5V182.5H53.8V154.9ZM65.2 167.1C66.7 167.1 67.6 166.2 67.6 164.9C67.6 163.6 66.7 162.7 65.2 162.7H62.6V167.1H65.2Z" fill="white"/>
          <path d="M101.3 154.9V162.3H88.6V164.9H100.2V171.9H88.6V175H101.7V182.4H79.8V154.9H101.3Z" fill="white"/>
          <path d="M105.5 154.9H114.2V164.3H122.5V154.9H131.2V182.4H122.5V172.6H114.2V182.4H105.5V154.9Z" fill="white"/>
          <path d="M106.7 119.4H115.8V129.2H124.5V119.4H133.6V148.2H124.5V137.9H115.8V148.2H106.7V119.4Z" fill="white"/>
          <path d="M135.2 174.1C135.2 174.1 136.9 173.2 137.3 169.7L139 154.8H158.8V174H161.7V187.3H153.3V182.3H141.8V187.3H133.4V174.1H135.2ZM150.5 163.2H145.9L145.3 169.8C145 173.3 143.2 174.2 143.2 174.2H150.5V163.2Z" fill="white"/>
          <path d="M172.5 154.9H183L192.2 182.4H182.8L181.5 177.6H174L172.7 182.4H163.3L172.5 154.9ZM179.5 170.6L177.7 164L176 170.6H179.5Z" fill="white"/>
          <path d="M22.7 119H44.4V126.7H31.7V128.5H36.7C42.8 128.5 46.9 132.6 46.9 138C46.9 143.4 42.8 147.5 36.7 147.5H22.7V119ZM35.8 139.8C37.2 139.8 37.8 139.1 37.8 138C37.8 136.9 37.1 136.2 35.8 136.2H31.7V139.8H35.8Z" fill="white"/>
          <path d="M50.1 119H59.1V133.7L69 119H77.1V147.5H68.1V132.8L58.2 147.5H50.1V119Z" fill="white"/>
          <path d="M79.9 138.5L88.9 137.6C88.9 137.6 89.4 139.9 91.4 139.9C92.8 139.9 93.4 139 93.4 138.1C93.4 137.2 92.7 136.3 91.4 136.3H88.2V129.5H91.4C92.3 129.5 93 129 93 128.1C93 127.2 92.3 126.7 91.4 126.7C89.8 126.7 89.4 128.5 89.4 128.5L80.4 127.6C80.6 122.6 84.7 118.6 91.7 118.6C98.9 118.6 102.8 122.4 102.8 126.7C102.8 130.8 98.7 132.6 98.7 132.6C98.7 132.6 103.4 134.4 103.4 139.4C103.4 143.9 99.3 148 92.1 148C84.4 148 80.1 143.7 79.9 138.5Z" fill="white"/>
          <path d="M137.8 119H159.9V126.7H146.8V129.4H158.8V136.6H146.8V139.8H160.4V147.5H137.8V119Z" fill="white"/>
          <path d="M163.1 133.3C163.1 125.2 169.7 118.6 178 118.6C190.2 118.6 192 129.4 192 129.4L183 130.3C183 130.3 181.6 127.1 178 127.1C174.8 127.1 172.1 129.8 172.1 133.2C172.1 136.6 174.8 139.3 178 139.3C181.6 139.3 183 136.1 183 136.1L192 137C192 137 190.2 147.8 178 147.8C169.6 148 163.1 141.4 163.1 133.3Z" fill="white"/>
          <path d="M136 20.1L179.3 33.5V103H191V20.1H136Z" fill="white"/>
        </svg>
        <span class="logotype-header left mobile">Бизнес<br>Аренда</span>
      </router-link>
      <div class="header-menu-text left flex flex-y-center mobile-nv">
        <router-link to="/investition">
          <span>Инвестиция</span>
        </router-link>
        <router-link to="/reinvestition">
          <span>Реинвестиция</span>
        </router-link>
        <router-link to="/management">
          <span>Управление</span>
        </router-link>
        <router-link to="/home">
          <span>Ремонт / Хоумстейджинг</span>
        </router-link>
        <router-link to="/ourprojects">
          <span>Наши Проекты</span>
        </router-link>
      </div>
      <div class="header-button-menu left flex flex-y-center">
        <a v-if="isAuth === false" @click.prevent="$root.$refs.modals.openModal('modalAuth')" target="_blank" class="circle-button-blue left flex flex-xy-center">
          <div class="circle-button-white left flex flex-xy-center">
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 9.6C13.6036 9.6 15.7143 7.45097 15.7143 4.8C15.7143 2.14903 13.6036 0 11 0C8.39637 0 6.28571 2.14903 6.28571 4.8C6.28571 7.45097 8.39637 9.6 11 9.6Z" fill="#111827"/>
              <path d="M0 24C0 17.8144 4.92487 12.8 11 12.8C17.0751 12.8 22 17.8144 22 24H0Z" fill="#111827"/>
            </svg>     
          </div>
        </a>
        <router-link v-else to="/profile" class="circle-button-blue left flex flex-xy-center">
          <div class="circle-button-white left flex flex-xy-center">
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 9.6C13.6036 9.6 15.7143 7.45097 15.7143 4.8C15.7143 2.14903 13.6036 0 11 0C8.39637 0 6.28571 2.14903 6.28571 4.8C6.28571 7.45097 8.39637 9.6 11 9.6Z" fill="#111827"/>
              <path d="M0 24C0 17.8144 4.92487 12.8 11 12.8C17.0751 12.8 22 17.8144 22 24H0Z" fill="#111827"/>
            </svg>     
          </div>
        </router-link>
        <div class="burger-menu right mobile" @click="openModal">
          <div class="black-bg right flex flex-xy-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5C17 5.55228 16.5523 6 16 6H4C3.44772 6 3 5.55228 3 5Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4C3.44772 11 3 10.5523 3 10Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3 15C3 14.4477 3.44772 14 4 14H16C16.5523 14 17 14.4477 17 15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15Z" fill="white"/>
            </svg>
          </div>
        </div>
        <div class="contacts-menu left flex flex-xy-center mobile-nv">
          <div class="header-number left flex-xy-center">

            <div class="gradient-hidden" @click="fadeGr()"></div>
            <a href="tel:+74997151060">+7 (499) 715-10-60</a>
          </div>
          <div class="contacts-buttons left flex flex-y-center">
            <div class="green-circle left flex flex-xy-center">
              <a class="flex flex-xy-center" href="https://api.whatsapp.com/send/?phone=79163856000&text&type=phone_number&app_absent=0" target="_blank">
                <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5001 37.15C31.0388 37.15 37.1501 31.0387 37.1501 23.5C37.1501 15.9613 31.0388 9.85001 23.5001 9.85001C15.9614 9.85001 9.8501 15.9613 9.8501 23.5C9.8501 25.9481 10.4946 28.2457 11.6231 30.2324L9.8501 37.15L16.9821 35.4962C18.9189 36.5508 21.1395 37.15 23.5001 37.15ZM23.5001 35.05C29.879 35.05 35.0501 29.8789 35.0501 23.5C35.0501 17.1211 29.879 11.95 23.5001 11.95C17.1212 11.95 11.9501 17.1211 11.9501 23.5C11.9501 25.9629 12.721 28.2458 14.0346 30.1205L13.0001 34L16.948 33.013C18.8097 34.2977 21.0671 35.05 23.5001 35.05Z" fill="white"/>
                  <path d="M20.3006 17.2705C19.9761 16.6186 19.4782 16.6763 18.9752 16.6763C18.0764 16.6763 16.6748 17.753 16.6748 19.7568C16.6748 21.399 17.3984 23.1966 19.8369 25.8858C22.1902 28.481 25.2822 29.8235 27.8492 29.7778C30.4162 29.7321 30.9444 27.5231 30.9444 26.7771C30.9444 26.4465 30.7392 26.2815 30.5978 26.2367C29.7231 25.8169 28.1097 25.0346 27.7426 24.8877C27.3755 24.7407 27.1838 24.9395 27.0647 25.0476C26.7318 25.3649 26.0719 26.2998 25.8459 26.5101C25.62 26.7204 25.2831 26.614 25.1429 26.5345C24.6271 26.3275 23.2284 25.7054 22.1136 24.6246C20.7348 23.2881 20.6539 22.8282 20.3941 22.4189C20.1863 22.0914 20.3388 21.8905 20.4149 21.8027C20.7119 21.4599 21.1221 20.9307 21.3061 20.6677C21.49 20.4047 21.344 20.0055 21.2564 19.7568C20.8795 18.6873 20.5602 17.792 20.3006 17.2705Z" fill="white"/>
                </svg>
              </a>
            </div>
            <div class="blue-circle left flex flex-xy-center" >
              <a class="flex flex-xy-center" href="https://t.me/BizArenda" target="_blank">
                <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.3998 7.81146L22.8535 23.7651C22.586 24.8911 21.8882 25.1713 20.8967 24.641L15.4933 20.8426L12.8861 23.2347C12.5977 23.5099 12.3563 23.7402 11.8002 23.7402L12.1884 18.4906L22.203 9.85819C22.6385 9.48792 22.1086 9.2827 21.5263 9.65302L9.14575 17.0894L3.81578 15.498C2.65641 15.1527 2.63547 14.3921 4.05707 13.8616L24.9047 6.2001C25.8699 5.85483 26.7146 6.40522 26.3998 7.81146Z" fill="white"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="header-menu-mobile mobile">
        <svg @click="openModal" class="close__svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="white" />
        </svg>

        <ul class="header-menu-list flex flex-column">
          <li class="blue">
            <span @click.prevent="goRoute('/investition')" class="flex flex-y-center">
              Инвестиция
            </span>
          </li>
          <li class="green">
            <span @click.prevent="goRoute('/reinvestition')" class="flex flex-y-center">
              Реинвестиция
            </span>
          </li>
          <li class="orange">
            <span @click.prevent="goRoute('/management')" class="flex flex-y-center">
              Управление
            </span>
          </li>
          <li class="yellow">
            <span @click.prevent="goRoute('/home','home')" class="flex flex-y-center">
              Хоумстейджинг
            </span>
          </li>
          <li class="blue">
            <span @click.prevent="goRoute('/repair', 'repair')" class="flex flex-y-center">
              Ремонт
            </span>
          </li>
          <li class="orange">
            <span @click.prevent="goRoute('/ourprojects')" class="flex flex-y-center">
              Наши проекты
            </span>
          </li>
        </ul>
        <div class="contacts-buttons left flex flex-y-center">

          <div class="header-number left flex-xy-center">
            <div class="gradient-hidden"></div>
            <a href="tel:+74997151060">+7 (499) 715-10-60</a>
          </div>
          <a href="https://api.whatsapp.com/send/?phone=79163856000&text&type=phone_number&app_absent=0" target="_blank" class="green-circle left flex flex-xy-center">

            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 32.95C25.5851 32.95 32.9501 25.5851 32.9501 16.5C32.9501 7.41492 25.5851 0.0500031 16.5 0.0500031C7.41496 0.0500031 0.0500488 7.41492 0.0500488 16.5C0.0500488 19.4503 0.82672 22.2192 2.18676 24.6133L0.0500488 32.95L8.64501 30.957C10.9792 32.2279 13.6553 32.95 16.5 32.95ZM16.5 30.4192C24.1874 30.4192 30.4193 24.1874 30.4193 16.5C30.4193 8.81262 24.1874 2.58077 16.5 2.58077C8.81267 2.58077 2.58082 8.81262 2.58082 16.5C2.58082 19.4681 3.50984 22.2193 5.09296 24.4785L3.8462 29.1538L8.60397 27.9644C10.8475 29.5126 13.5679 30.4192 16.5 30.4192Z" fill="white"/>
              <path d="M12.6446 8.99261C12.2535 8.20703 11.6535 8.27658 11.0474 8.27658C9.96413 8.27658 8.27505 9.57411 8.27505 11.9889C8.27505 13.968 9.14713 16.1344 12.0858 19.3752C14.9218 22.5027 18.6481 24.1206 21.7417 24.0656C24.8352 24.0105 25.4717 21.3484 25.4717 20.4494C25.4717 20.0509 25.2244 19.8521 25.0541 19.7981C23.9999 19.2921 22.0555 18.3494 21.6131 18.1723C21.1707 17.9952 20.9398 18.2348 20.7962 18.3651C20.395 18.7474 19.5997 19.8742 19.3274 20.1276C19.0551 20.381 18.6492 20.2528 18.4802 20.157C17.8586 19.9075 16.173 19.1577 14.8295 17.8553C13.1678 16.2446 13.0703 15.6904 12.7573 15.1971C12.5068 14.8025 12.6906 14.5603 12.7823 14.4545C13.1403 14.0414 13.6346 13.4037 13.8563 13.0867C14.078 12.7698 13.902 12.2886 13.7964 11.9889C13.3423 10.7 12.9575 9.62107 12.6446 8.99261Z" fill="white"/>
            </svg>
          </a>
          <a href="https://t.me/BizArenda" target="_blank" class="blue-circle left flex flex-xy-center" >
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.3998 7.81144L22.8535 23.7651C22.586 24.8911 21.8882 25.1713 20.8967 24.641L15.4933 20.8426L12.8861 23.2347C12.5977 23.5099 12.3563 23.7402 11.8002 23.7402L12.1884 18.4906L22.203 9.85817C22.6385 9.4879 22.1086 9.28269 21.5263 9.65301L9.14575 17.0894L3.81578 15.498C2.65641 15.1527 2.63547 14.392 4.05707 13.8616L24.9047 6.20009C25.8699 5.85482 26.7146 6.4052 26.3998 7.81144Z" fill="white"/>
            </svg>
          </a>
        </div>
        <div class="header-btn-form flex flex-x-center left">
          <a class="flex flex-x-center" @click.prevent="scrollToForm()">
            Оставить заявку
          </a>
        </div>
      </div>
    </div>

  </header>
</template>

<style scoped>

</style>